import styled, { css } from 'styled-components'

export interface SectionHeaderTitlesStyledProps {
  $direction?: 'horizontal' | 'vertical'
  $justify?: 'start' | 'center' | 'end' | 'between' | 'around'
  $spacing?: 'small' | 'medium' | 'large'
  $responsive?: boolean
}

const spacingValues = {
  small: '12px',
  medium: '16px',
  large: '24px',
}

const justifyValues = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  between: 'space-between',
  around: 'space-around',
}

export const Container = styled.header.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<SectionHeaderTitlesStyledProps>`
  display: flex;
  width: 100%;

  ${({ $direction = 'horizontal', $justify = 'between' }) =>
    $direction === 'horizontal'
      ? css`
          flex-direction: row;
          align-items: center;
          justify-content: ${justifyValues[
            $justify === 'start' ? 'start' : $justify
          ]};
        `
      : css`
          flex-direction: column;
          align-items: ${justifyValues[
            $justify === 'between' ? 'start' : $justify
          ]};
        `}

  gap: ${({ $spacing = 'medium' }) =>
    spacingValues[$spacing as keyof typeof spacingValues]};

  ${({ $responsive = true, $direction = 'horizontal', $spacing = 'medium' }) =>
    $responsive && $direction === 'horizontal'
      ? css`
          @media (max-width: 768px) {
            flex-direction: column;
            align-items: stretch;
            gap: ${spacingValues[$spacing as keyof typeof spacingValues]};

            .actions-container {
              align-self: stretch;
            }
          }
        `
      : ''}
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0; /* Prevent overflow in flex */
`

export const ActionsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
`
